import React from 'react';

type EventUtilizationTileProps = {
  count: number;
  label: string;
  testId: string;
};

export const EventUtilizationTile = ({
  count,
  label,
  testId,
}: EventUtilizationTileProps) => {
  return (
    <div
      className="flex flex-1 flex-col items-center overflow-hidden rounded-2xl border border-neutral-b4 px-5.25 pt-6 pb-5.75"
      data-testid={testId}
    >
      <div className="flex h-8 items-center">
        <span className="text-kpi-count text-gray-900">{count}</span>
      </div>
      <div className="flex h-kpi-label items-start pt-1">
        <span className="whitespace-nowrap text-title text-neutral-b2">
          {label}
        </span>
      </div>
    </div>
  );
};
